import * as types from './strategicCapsVsDemandActionType';

// Notes Edit Actions
export const fetchStrategicCapsNotesEditRequest = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_REQUEST,
    payload,
});
export const fetchStrategicCapsNotesEditSuccess = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_SUCCESS,
    payload,
});
export const fetchStrategicCapsNotesEditFailure = (error) => ({
    type: types.FETCH_STRATEGIC_CAPS_NOTES_EDIT_FAILURE,
    error,
});

// Notes Save Actions
export const fetchStrategicCapsNotesSaveRequest = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_REQUEST,
    payload,
});
export const fetchStrategicCapsNotesSaveSuccess = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_SUCCESS,
    payload,
});
export const fetchStrategicCapsNotesSaveFailure = (error) => ({
    type: types.FETCH_STRATEGIC_CAPS_NOTES_SAVE_FAILURE,
    error,
});

// Delete Report Actions
export const deleteStrategicCapsReportRequest = (payload) => ({
    type: types.DELETE_STRATEGIC_CAPS_REPORT_REQUEST,
    payload,
});
export const deleteStrategicCapsReportSuccess = (payload) => ({
    type: types.DELETE_STRATEGIC_CAPS_REPORT_SUCCESS,
    payload,
});
export const deleteStrategicCapsReportFailure = (error) => ({
    type: types.DELETE_STRATEGIC_CAPS_REPORT_FAILURE,
    error,
});

// Export Report Actions
export const exportStrategicCapsReportRequest = (payload) => ({
    type: types.EXPORT_STRATEGIC_CAPS_REPORT_REQUEST,
    payload,
});
export const exportStrategicCapsReportSuccess = (payload) => ({
    type: types.EXPORT_STRATEGIC_CAPS_REPORT_SUCCESS,
    payload,
});
export const exportStrategicCapsReportFailure = (error) => ({
    type: types.EXPORT_STRATEGIC_CAPS_REPORT_FAILURE,
    error,
});

// Fetch Reports Actions
export const fetchStrategicCapsReportsRequest = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_REPORTS_REQUEST,
    payload,
});
export const fetchStrategicCapsReportsSuccess = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_REPORTS_SUCCESS,
    payload,
});
export const fetchStrategicCapsReportsFailure = (error) => ({
    type: types.FETCH_STRATEGIC_CAPS_REPORTS_FAILURE,
    error,
});

// Fetch Dropdown Actions
export const fetchStrategicCapsDropdownRequest = () => ({
    type: types.FETCH_STRATEGIC_CAPS_DROPDOWN_REQUEST,
});
export const fetchStrategicCapsDropdownSuccess = (payload) => ({
    type: types.FETCH_STRATEGIC_CAPS_DROPDOWN_SUCCESS,
    payload,
});
export const fetchStrategicCapsDropdownFailure = (error) => ({
    type: types.FETCH_STRATEGIC_CAPS_DROPDOWN_FAILURE,
    error,
});

// Fetch Filter Dropdown Actions
export const fetchFilterStrategicCapsDropdownRequest = () => ({
    type: types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_REQUEST,
});
export const fetchFilterStrategicCapsDropdownSuccess = (payload) => ({
    type: types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_SUCCESS,
    payload,
});
export const fetchFilterStrategicCapsDropdownFailure = (error) => ({
    type: types.FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_FAILURE,
    error,
});

// Fetch Week Quarter Dropdown Actions
export const fetchWeekQuarterCapsDropdownRequest = (payload) => ({
    type: types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_REQUEST,
    payload,
});
export const fetchWeekQuarterCapsDropdownSuccess = (payload) => ({
    type: types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_SUCCESS,
    payload,
});
export const fetchWeekQuarterCapsDropdownFailure = (error) => ({
    type: types.FETCH_WEEK_QUARTER_CAPS_DROPDOWN_FAILURE,
    error,
});

// Fetch wRVU Surplus Worklist View Table Actions
export const fetchWRVUSurplusWorklistRequest = (payload) => ({
    type: types.FETCH_WRVU_SURPLUS_WORKLIST_REQUEST,
    payload,
});
export const fetchWRVUSurplusWorklistSuccess = (payload) => ({
    type: types.FETCH_WRVU_SURPLUS_WORKLIST_SUCCESS,
    payload,
});
export const fetchWRVUSurplusWorklistFailure = (error) => ({
    type: types.FETCH_WRVU_SURPLUS_WORKLIST_FAILURE,
    error,
});

// Fetch wRVU Surplus (Gap) View Table Actions
export const fetchWRVUSurplusRequest = (payload) => ({
    type: types.FETCH_WRVU_SURPLUS_REQUEST,
    payload,
});
export const fetchWRVUSurplusSuccess = (payload) => ({
    type: types.FETCH_WRVU_SURPLUS_SUCCESS,
    payload,
});
export const fetchWRVUSurplusFailure = (error) => ({
    type: types.FETCH_WRVU_SURPLUS_FAILURE,
    error,
});

// Fetch FTE Surplus (Gap) View Table Actions
export const fetchFTESurplusRequest = (payload) => ({
    type: types.FETCH_FTE_SURPLUS_REQUEST,
    payload,
});
export const fetchFTESurplusSuccess = (payload) => ({
    type: types.FETCH_FTE_SURPLUS_SUCCESS,
    payload,
});
export const fetchFTESurplusFailure = (error) => ({
    type: types.FETCH_FTE_SURPLUS_FAILURE,
    error,
});

// Fetch Legend Actions
export const fetchLegendRequest = () => ({
    type: types.FETCH_LEGEND_REQUEST,
});
export const fetchLegendSuccess = (payload) => ({
    type: types.FETCH_LEGEND_SUCCESS,
    payload,
});
export const fetchLegendFailure = (error) => ({
    type: types.FETCH_LEGEND_FAILURE,
    error,
});

// Update Reducer
export const updateStrategicCapsReducer = (payload) => ({
    type: types.UPDATE_STRATEGIC_CAPS_REDUCER,
    payload,
});

// Draft  Actions
export const draftStrategicCapsRequest = (payload) => ({
    type: types.DRAFT_STRATEGIC_CAPS_REQUEST,
    payload,
});
export const draftStrategicCapsSuccess = (payload) => ({
    type: types.DRAFT_STRATEGIC_CAPS_SUCCESS,
    payload,
});
export const draftStrategicCapsFailure = (error) => ({
    type: types.DRAFT_STRATEGIC_CAPS_FAILURE,
    error,
});

// Publish  Actions
export const publishStrategicCapsRequest = (payload) => ({
    type: types.PUBLISH_STRATEGIC_CAPS_REQUEST,
    payload,
});
export const publishStrategicCapsSuccess = (payload) => ({
    type: types.PUBLISH_STRATEGIC_CAPS_SUCCESS,
    payload,
});
export const publishStrategicCapsFailure = (error) => ({
    type: types.PUBLISH_STRATEGIC_CAPS_FAILURE,
    error,
});

// filter Apply  Actions
export const filterStrategicCapsApplyRequest = (payload) => ({
    type: types.FILTER_STRATEGIC_CAPS_APPLY_REQUEST,
    payload,
});
export const filterStrategicCapsApplySuccess = (payload) => ({
    type: types.FILTER_STRATEGIC_CAPS_APPLY_SUCCESS,
    payload,
});
export const filterStrategicCapsApplyFailure = (error) => ({
    type: types.FILTER_STRATEGIC_CAPS_APPLY_FAILURE,
    error,
});

// get Worklist by RPCEID Actions
export const rpceWorklistStrategicCapsRequest = (payload) => ({
    type: types.GET_WORKLIST_BY_RPCEID_REQUEST,
    payload,
});
export const rpceWorklistStrategicCapsSuccess = (payload) => ({
    type: types.GET_WORKLIST_BY_RPCEID_SUCCESS,
    payload,
});
export const rpceWorklistStrategicCapsFailure = (error) => ({
    type: types.GET_WORKLIST_BY_RPCEID_FAILURE,
    error,
});

// Get BlockPlanningCapacityVsDemandTableReport Actions
export const GetBlockPlanningCapacityVsDemandTableReport = (payload) => ({
    type: types.GET_STRATEGIC_CAPS_VS_DEMAND_REQUEST,
    payload,
});
export const GetBlockPlanningCapacityVsDemandTableReportSuccess = (payload) => ({
    type: types.GET_STRATEGIC_CAPS_VS_DEMAND_SUCCESS,
    payload,
});
export const GetBlockPlanningCapacityVsDemandTableReportFailure = (error) => ({
    type: types.GET_STRATEGIC_CAPS_VS_DEMAND_FAILURE,
    error,
});

export const fetchCapsDemandFilterByIdRequest = (tableId) => ({
  type: types.FETCH_CAPS_DEMAND_FILTER_BY_ID_REQUEST,
  payload: tableId,
});

export const fetchCapsDemandFilterByIdSuccess = (data) => ({
  type: types.FETCH_CAPS_DEMAND_FILTER_BY_ID_SUCCESS,
  payload: data,
});

export const fetchCapsDemandFilterByIdFailure = (error) => ({
  type: types.FETCH_CAPS_DEMAND_FILTER_BY_ID_FAILURE,
  payload: error,
});

